import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef } from '@angular/core';
import { Letter } from '@schoolbelle/api/letter';
import { reduce, forEach, isMatch, flatten } from 'lodash-es';
import { ReadAnswerInfo, ReadTableRowData, LetterReadTableService } from '@schoolbelle/api/letter-read';
import { LoadingService } from '@schoolbelle/common/loading';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { GroupService } from '@schoolbelle/api/group';
import { LetterTargetService } from '@schoolbelle/api/letter-target';
import { ExcelService, ExcelWorkBookData } from '@schoolbelle/api/excel';
import { DialogService } from '@schoolbelle/common/dialog';
import { TranslationService } from '@schoolbelle/common/translation';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

export type MemberlistType = 'issuance'|'now'|'aWeekAfter'|'deadline';

@Component({
  selector: 'app-read-list',
  templateUrl: './read-list.component.html',
  styleUrls: ['./read-list.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
  providers:[DatePipe],
})
export class ReadListComponent implements OnInit {
  @Input() letter:Partial<Letter>;
  @Input() rows:ReadTableRowData[] = [];
  anonymous:boolean = false;
  poll:boolean = false;
  hasSurvey:boolean = false;



  showDetails:boolean = false;
  pushTo:'unread'|'unanswered' = 'unread';
  downloadFrom:'read'|'answered'|'unread'|'unanswered' = 'read';
  push_cnt:number = 0;

  memberlist:MemberlistType;
  showSimpleDetailsCheckOptions = false;
  showMemberlistCheckOptions = false;
  
  constructor(
    public group:GroupService,
    protected dialogs:DialogService,
    protected letterReadTable: LetterReadTableService,
    protected excel:ExcelService,
    protected target:LetterTargetService,
    protected loading:LoadingService,
    protected toastr:ToastrService,
    protected elementRef:ElementRef,
    protected translation:TranslationService,
    protected cdRef:ChangeDetectorRef,
    protected datePipe:DatePipe,

    protected route:ActivatedRoute,
  ) {
    
  }
  
  filtered:ReadTableRowData[] = [];
  filteredAndQuried:ReadTableRowData[] = [];
  filterSettings:{[key:string]:0|1}[];
  query:string = ''; 
  get translateFilterSettings ():'none'|'partial'|'all' {
    if (this.filterSettings.length === (this.hasSurvey ? 4 : 2)) return 'all';
    if (this.filterSettings.length === 0) return 'none';
    return 'partial';
  }
  getFilteredRows (rows:ReadTableRowData[] = this.rows, filterSettings:{[key:string]:0|1}[] = this.filterSettings):ReadTableRowData[] {
    return rows.filter((row:ReadTableRowData)=>{
      const readAnswerInfoList:ReadAnswerInfo[] = [row[3], row[4], row[5]];
      const reduced = reduce(readAnswerInfoList, (acc, info)=>{
        forEach(info, (val, key)=>{
          if (val !== 0 || typeof acc[key] === 'undefined') acc[key] = val ? 1 : 0;
        })
        return acc;
      }, {});
      return filterSettings.find(fs=>isMatch(reduced, fs)) ? true : false;
    })
  }
  getQueriedRows (filtered:ReadTableRowData[] = this.filtered, query:string = this.query):ReadTableRowData[]  {
    const bits = query.split(' ');
    return filtered.filter(r=>{
      const haystacks = r.slice(0, 3).map(v=>v.toString());
      const unmatched = bits.find(bit=>{
        const notfound = haystacks.find(h=>h.match(bit) ? true : false ) ? false : true;
        return notfound;
      }) ? false : true; 
      return unmatched;
    });
  }
  hasRead (readAnswerInfoList:ReadAnswerInfo[]) {
    const reduced = reduce(readAnswerInfoList, (acc, info)=>{
      forEach(info, (val, key)=>{
        if (val !== 0 || typeof acc[key] === 'undefined') acc[key] = val ? 1 : 0;
      })
      return acc;
    }, {});
    return isMatch(reduced, {read:1});

  }
  hasReplied (readAnswerInfoList:ReadAnswerInfo[]) {
    const reduced = reduce(readAnswerInfoList, (acc, info)=>{
      forEach(info, (val, key)=>{
        if (val !== 0 || typeof acc[key] === 'undefined') acc[key] = val ? 1 : 0;
      })
      return acc;
    }, {});
    return isMatch(reduced, {answered:1});

  }

  target_cnt:number= 0;
  read_cnt:number= 0;
  reply_cnt:number= 0;
  refreshCnts () {
    this.target_cnt = 0;
    this.read_cnt = 0
    this.reply_cnt = 0;
    this.filteredAndQuried.forEach(row=>{
      this.target_cnt ++;
      const hasRead:boolean = this.hasRead(row.slice(3) as ReadAnswerInfo[]);
      const hasReplied:boolean = this.hasReplied(row.slice(3) as ReadAnswerInfo[]);
      if (hasReplied) {
        this.read_cnt ++
        this.reply_cnt ++;
      } 
      else if (hasRead) {
        this.read_cnt ++
      }
    });    
    const repushTargets = this.letterReadTable.getRepushTargets(this.pushTo);
    this.push_cnt = flatten(this.target.getMembersInTargets(repushTargets).filter(m=>m.member_type.match(/student|faculty/))).length;
  }
  updateMemberlist (type:MemberlistType) {
    if (this.memberlist === type) return;
    this.memberlist = type;
    const subscription = this.letterReadTable.checkIn(this.letter as any, this.getAtFromMemberlistType())
    .subscribe(({letter, rows})=>{
      this.letter = letter;
      this.rows = rows;
      this.refresh();
      this.cdRef.detectChanges();
    })
    this.loading.open({message:this.translation.get('read-list-fetching-memberlist'), busy:subscription})
  }
  refresh () {
    this.filtered = this.getFilteredRows();
    this.filteredAndQuried = this.getQueriedRows();
    this.refreshCnts();
    this.cdRef.detectChanges();
  }
  getAtFromMemberlistType () {
    switch (this.memberlist) {
      case 'issuance':
        return this.letter.created_at;
      case 'aWeekAfter':
        return this.letter.created_at + 7 * 24 * 60 * 60 * 1000;
      case 'deadline':
        return this.letter.deadline;
      default:
        return Date.now();
    }

  }
  getMemberlistTypeFromAt () {
    switch (this.letterReadTable.at) {
      case this.letter.created_at:
        return 'issuance';
      case this.letter.created_at + 7 * 24 * 60 * 60 * 1000:
        return 'aWeekAfter';
      case this.letter.deadline :
        return 'deadline';
      default:
        return 'now';
    }
  }

  ngOnInit () {
    if (this.route.snapshot.data.data) {
      const {letter, rows} = this.route.snapshot.data.data;
      this.letter = letter;
      this.rows = rows;
    }

    this.hasSurvey = this.letter && (this.letter.questionnaire_id || this.letter.survey_id || this.letter.survey_id_g3) ? true : false;
    this.memberlist = this.getMemberlistTypeFromAt();

    if (this.hasSurvey) {
      this.pushTo = 'unanswered';
      this.downloadFrom = 'answered';
      this.filterSettings = [{read:1}, {read:0}, {answered:1}, {answered:0}];
      this.anonymous = this.letter && this.letterReadTable.isSurveyAnonymous();    
      this.poll = this.letterReadTable.isSurveyPoll();
    } else {
      this.filterSettings = [{read:1}, {read:0}];
    }

    this.refresh();
  }

  isChecked (key:string, val:0|1) {
    return this.filterSettings.find(ob=>ob[key] === val) ? true : false
  }
  toggle (key:string, val:0|1) {
    if (this.isChecked(key, val)) {
      this.filterSettings.splice(this.filterSettings.findIndex(ob=>ob[key] === val), 1);
    } else {
      this.filterSettings.push({[key]:val});
    }

    this.refresh();
  }
  push () {
    const posted_at = (<any>this.letter).posted_at;
    const too_early_after_posting:boolean = posted_at && Date.now() - posted_at < 60 * 60 * 1000; 

    this.dialogs.confirm(
      too_early_after_posting ? this.translation.get('read-list-repush-confirm-too-early') : this.translation.get('read-list-repush-confirm')
    )
    .subscribe(bool=>{
      if (!bool) return;
      const subscription = this.letterReadTable.push({target_type:this.pushTo, prefix:this.translation.get('read-list-repush-prefix')}).subscribe(()=>this.toastr.success(this.translation.get('read-list-repush-success')), (e:HttpErrorResponse)=>{
        this.toastr.error(this.translation.get(`read-list-repush-${e.status}-error`) || e.error || e.message)
      });
      this.loading.open({message:this.translation.get('read-list-repushing'), busy:subscription});
    });
  }
  downloadAsExcel (from:'all'|'read'|'answered'|'unread'|'unanswered') {
    const sheets:ExcelWorkBookData = {};
    const data:(string|number)[][] = [
      this.letter.type !== 'facultynews' ? [
        this.translation.get('read-list-class'),
        this.translation.get('read-list-number'), 
        this.translation.get('read-list-name'), 
        this.translation.get('read-list-parent1'),
        this.translation.get('read-list-parent2'),
        this.translation.get('read-list-student')
      ] : [
        this.translation.get('read-list-school'),
        this.translation.get('read-list-num'),
        this.translation.get('read-list-name'),
        '',
      ],
    ];
    this.filteredAndQuried.forEach((row:ReadTableRowData)=>{
      const statuses = (this.letter.type !== 'facultynews' ? [4,5,3] : [3]).map(index=>{
        let text:string = '';
        const read_timstamp_list = this.letterReadTable.getTimestampFromMultipleReadStatuses([row[index]] as any, 'read');
        if (read_timstamp_list.length) {
          text += `${this.translation.get(`read-list-read`)}@${read_timstamp_list.map(ts=>this.datePipe.transform(ts, 'MM-dd HH:mm:ss')).join(',')}`
        }
        const answered_timstamp_list = this.letterReadTable.getTimestampFromMultipleReadStatuses([row[index]] as any, 'answered');
        if (answered_timstamp_list.length) {
          if (text) text+= ', ';
          text += `${this.translation.get(`read-list-answered`)}@${answered_timstamp_list.map(ts=>this.datePipe.transform(ts, 'MM-dd HH:mm:ss')).join(',')}`
        }
        return text;
      })

      data.push([ 
        row[0],
        row[1],
        row[2],
        ...statuses
      ]);
    })
    sheets['Sheet1'] = data;
    const ob = this.excel.write(sheets, `목록`);
    this.loading.open({message:this.translation.get('read-list-downloading'), busy:ob.subscribe()});
  }  

  ngAfterViewInit(): void {
    forEach(this.elementRef.nativeElement.querySelectorAll("div[translation-text]"), (el) => this.translation.set(el.id, el.attributes["translation-text"].value));
  }


  single: any[] = [];

  view: any[] = [3700, 200];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = false;
  showXAxisLabel = false;
  // xAxisLabel = "Country";
  showYAxisLabel = false;
  // yAxisLabel = "Population";

  colorScheme = {
    domain: ["#F96E32", '#32db64']
  };  
  axisFormat(val) {
    if (val % 1 === 0) {
      return val.toLocaleString();
    } else {
      return '';
    }  
  }  
}    